@if (isOffline) {
  <div class="p-4">
    <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='adminOfflineMessage'></ebs-offline-message>
  </div>
}

@if (!isOffline) {
  <div class="course-admin-wrapper main-content scrollable full-height-minus-header">
    <div class="scrollbar">
      @if (!isLoading) {
        <div class="card">
          <div class="col-12 col-xl-8 offset-xl-2">
            <div class="p-2">
              <span>
                <a [routerLink]="['/course-admin']"><i class="fas fa-chevron-circle-left fa-lg"></i> Go back to course
              admin</a>
            </span>
          </div>
          <div class="manage-logos">
            <p class="manage-logos-header">Manage logos for {{courseName}}</p>
            @if (!isAdminForCourse) {
              <div role="warning" class="alert alert-warning beta-version ng-star-inserted"
                >
                <p>
                  To manage logos for a course you must be a portal administrator with access to the course.
                </p>
              </div>
            }
            @if (primaryTileLogoLoaded && secondaryTileLogoLoaded && primaryCourseLogoLoaded && secondaryCourseLogoLoaded) {
              <div>
                <div class="row">
                  <div class="col-12 col-md-6 logo-upload-section">
                    <b>Primary Course Logo</b>
                    <p>Displayed at the top of the screen when viewing a course.</p>
                    <div>
                      <label for="primary-course-upload" class="btn btn-primary">Select and upload image (PNG, JPG, GIF,
                      SVG)</label>
                      <input id="primary-course-upload" type="file" (change)="onFileChange($event, primaryCourseLogoType)"
                        accept=".png, .gif, .jpg, .jpeg, .svg" />
                      </div>
                      @if (primaryCourseLogo != null) {
                        <div class="current-logo">
                          <div>Current primary course image (shown on blue background):</div>
                          <div class="logo">
                            <img src="{{primaryCourseLogoSrcContent}}" />
                          </div>
                          <div class="remove-logo">
                            <button class="btn btn-outline-secondary" type="button"
                            (click)="onRemoveLogoClick(primaryCourseLogoType)">Remove primary course logo</button>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-12 col-md-6 logo-upload-section">
                      <b>Secondary Course Logo</b>
                      <p>Displayed at the top of the screen when viewing a course.</p>
                      <div>
                        <label for="secondary-course-upload" class="btn btn-primary">Select and upload image (PNG, JPG, GIF,
                        SVG)</label>
                        <input id="secondary-course-upload" type="file" (change)="onFileChange($event, secondaryCourseLogoType)"
                          accept=".png, .gif, .jpg, .jpeg, .svg" />
                        </div>
                        @if (secondaryCourseLogo != null) {
                          <div class="current-logo">
                            <div>Current secondary course image (shown on blue background):</div>
                            <div class="logo">
                              <img src="{{secondaryCourseLogoSrcContent}}" />
                            </div>
                            <div class="remove-logo">
                              <button class="btn btn-outline-secondary" type="button"
                              (click)="onRemoveLogoClick(secondaryCourseLogoType)">Remove secondary course logo</button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row tile-row">
                      <div class="col-12 col-md-6 logo-upload-section">
                        <b>Primary Tile Logo</b>
                        <p>Displayed in the course tile on the students dashboard.</p>
                        <div>
                          <label for="primary-tile-upload" class="btn btn-primary">Select and upload image (PNG, JPG, GIF, SVG)</label>
                          <input id="primary-tile-upload" type="file" (change)="onFileChange($event, primaryTileLogoType)"
                            accept=".png, .gif, .jpg, .jpeg, .svg" />
                          </div>
                          @if (primaryTileLogo != null) {
                            <div class="current-logo">
                              <div>Current primary tile image:</div>
                              <img src="{{primaryTileLogoSrcContent}}" />
                              <div class="remove-logo">
                                <button class="btn btn-outline-secondary" type="button"
                                (click)="onRemoveLogoClick(primaryTileLogoType)">Remove primary tile logo</button>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="col-12 col-md-6 logo-upload-section">
                          <b>Secondary Tile Logo</b>
                          <p>Displayed in the course tile on the students dashboard.</p>
                          <div>
                            <label for="secondary-tile-upload" class="btn btn-primary">Select and upload image (PNG, JPG, GIF, SVG)</label>
                            <input id="secondary-tile-upload" type="file" (change)="onFileChange($event, secondaryTileLogoType)"
                              accept=".png, .gif, .jpg, .jpeg, .svg" />
                            </div>
                            @if (secondaryTileLogo != null) {
                              <div class="current-logo">
                                <div>Current secondary tile image:</div>
                                <img src="{{secondaryTileLogoSrcContent}}" />
                                <div class="remove-logo">
                                  <button class="btn btn-outline-secondary" type="button"
                                  (click)="onRemoveLogoClick(secondaryTileLogoType)">Remove secondary tile logo</button>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }